import { styled } from '@linaria/react';
import { useSpring, animated } from 'react-spring';

import useSequence from './use-sequence.hook';
import Label from './Label';
import {
  BaseWrapper,
  Layer as BaseLayer,
  BaseElement,
  BaseMargin,
  SPRING_CONFIGS,
} from './bits';

function MarginCollapseOpposing() {
  const [stepIndex, step, handlers] = useSequence({
    mode: 'interactive',
  });

  const offsetBy = 20;
  const xOffset = offsetBy * 0.6;
  const yOffset = offsetBy - xOffset;

  const firstSpring = useSpring({
    transform: `translate(
      ${stepIndex === 0 ? 0 : -xOffset}%,
      ${stepIndex === 0 ? 0 : yOffset}%)`,
    config: SPRING_CONFIGS[0],
  });

  const secondSpring = useSpring({
    transform: `translate(
      ${stepIndex === 0 ? 0 : xOffset}%,
      ${stepIndex === 0 ? 0 : -yOffset}%)`,
    config: SPRING_CONFIGS[0],
  });

  return (
    <Wrapper {...handlers}>
      <Skew>
        <Layer style={{ zIndex: 2, ...firstSpring }}>
          <Element>First</Element>
          <Margin />
        </Layer>

        <Layer style={{ ...secondSpring }}>
          <Margin />
          <Element>Second</Element>
        </Layer>
      </Skew>
    </Wrapper>
  );
}

const Wrapper = styled(BaseWrapper)`
  height: 260px;
  display: flex;
  width: 450px;
  height: 210px;
  max-width: 90vw;
  margin-top: 128px;
`;

const Layer = styled(animated.div)`
  flex: 1;
  position: relative;
  height: 125px;
  will-change: transform;
  display: flex;
`;

const Element = styled(BaseElement)`
  height: 100%;
  flex: 1;
`;
const Margin = styled(BaseMargin)`
  height: 100%;
  width: 24px;
`;

const Skew = styled.div`
  width: 100%;
  display: flex;
  transform: skewY(20deg);
`;

export default MarginCollapseOpposing;
